import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Results, PageWrapper } from './style';
import { NoResult, Text } from '../../../ui/atoms';
import { COURSE_CATEGORIES_GET } from '../../redux/actions/courselist';
import { Container } from '../../../ui/gridSystem';
import Tabs from '../../../ui/atoms/Tabs';
import CourseResults from './CourseResults';
import DocumentsResults from './DocumentResults';
import { DOCUMENTS_CATEGORIES_GET } from '../../redux/actions/documents';
import {
  BOOKMARK_COURSES_GET,
  BOOKMARK_DOCUMENTS_GET,
  BOOKMARK_EVENTS_GET,
  BOOKMARK_MODULES_GET,
} from '../../redux/actions/bookmarks';
import ModalLeaveCourse from '../../../ui/atoms/Modals/ModalLeaveCourse';
import ModalSurvey from '../../../ui/atoms/Modals/ModalSurvey';
import ModuleResults from './ModuleResults';
import EventResults from './EventResults';

const defaultTabs = [
  { value: 'courses', label: 'Corsi' },
  { value: 'modules', label: 'Moduli' },
  { value: 'events', label: 'Eventi' },
  { value: 'documents', label: 'Documenti' },
];

const Bookmarks = ({
  getCourses,
  getModules,
  getEvents,
  getDocuments,
  coursePager,
  modulePager,
  eventPager,
  docPager,
  getCategories,
  getDocumentCategories,
}) => {
  const [tabs, setTabs] = useState(defaultTabs);
  const [activeTab, setActiveTab] = useState(defaultTabs[0]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getCategories();
    getDocumentCategories();
    getCourses();
    getModules();
    getEvents();
    getDocuments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const newTabs = [...defaultTabs];
    newTabs[0].items = coursePager?.total_items ?? 0;
    newTabs[1].items = modulePager?.total_items ?? 0;
    newTabs[2].items = eventPager?.total_items ?? 0;
    newTabs[3].items = docPager?.total_items ?? 0;
    setTabs(newTabs);
  }, [
    coursePager?.total_items,
    eventPager?.total_items,
    modulePager?.total_items,
    docPager?.total_items,
  ]);

  const getPageResults = () => {
    if (
      typeof docPager?.total_items !== 'number' ||
      typeof coursePager?.total_items !== 'number' ||
      typeof modulePager?.total_items !== 'number'
    ) {
      return 'Non hai contenuti salvati in "Preferiti"';
    }
    return `Hai ${
      coursePager.total_items + modulePager.total_items + docPager.total_items
    } contenuti salvati in "Preferiti"`;
  };

  return (
    <>
      <Container>
        <Text type="h1" mb={8}>
          Preferiti
        </Text>
        <Results>{getPageResults()}</Results>
        {/* TABS */}
        <Tabs
          tabs={tabs}
          selected={activeTab}
          onChange={(tab) => {
            setActiveTab(tab);
          }}
        />
        <PageWrapper className={activeTab?.value === 'courses' ? 'active' : ''}>
          <CourseResults active={activeTab?.value === 'courses'} />
        </PageWrapper>
        <PageWrapper className={activeTab?.value === 'modules' ? 'active' : ''}>
          <ModuleResults active={activeTab?.value === 'modules'} />
        </PageWrapper>
        <PageWrapper className={activeTab?.value === 'events' ? 'active' : ''}>
          <EventResults active={activeTab?.value === 'events'} />
        </PageWrapper>
        <PageWrapper
          className={activeTab?.value === 'documents' ? 'active' : ''}
        >
          <DocumentsResults active={activeTab?.value === 'documents'} />
        </PageWrapper>
        {!activeTab && <NoResult />}
      </Container>
      <ModalLeaveCourse />
      <ModalSurvey />
    </>
  );
};

Bookmarks.propTypes = {
  // HOC (connect, state)
  coursePager: PropTypes.object,
  modulePager: PropTypes.object,
  eventPager: PropTypes.object,
  docPager: PropTypes.object,
  //HOC (connect, dispatch)
  getCategories: PropTypes.func.isRequired,
  getCourses: PropTypes.func.isRequired,
  getModules: PropTypes.func.isRequired,
  getEvents: PropTypes.func.isRequired,
  getDocuments: PropTypes.func.isRequired,
  getDocumentCategories: PropTypes.func.isRequired,
};

export default connect(
  (state) => {
    const {
      courses: { pager: coursePager },
      modules: { pager: modulePager },
      events: { pager: eventPager },
      documents: { pager: docPager },
    } = state.bookmarks;
    return {
      coursePager,
      modulePager,
      eventPager,
      docPager,
    };
  },
  (dispatch) => ({
    getCourses: () => dispatch({ type: BOOKMARK_COURSES_GET._REQUEST }),
    getModules: () => dispatch({ type: BOOKMARK_MODULES_GET._REQUEST }),
    getEvents: () => dispatch({ type: BOOKMARK_EVENTS_GET._REQUEST }),
    getDocuments: () => dispatch({ type: BOOKMARK_DOCUMENTS_GET._REQUEST }),
    getCategories: () => dispatch({ type: COURSE_CATEGORIES_GET._REQUEST }),
    getDocumentCategories: () =>
      dispatch({ type: DOCUMENTS_CATEGORIES_GET._REQUEST }),
  })
)(Bookmarks);
